module.exports = __webpack_public_path__ + "img/ic_moderator.38859a3b.png";